import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import OrderableImages from "components/subComponents/OrderableImages";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionGallery from "hooks/form/blocks/useSectionGallery";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum } from "types/enums";

function SectionGalleryForm({ blockId }: { blockId: BlockEnum }) {
    const { buttonDelete, orderableImagesHook } = useSectionGallery();

    const { formHook } = orderableImagesHook;

    useCheckSectionErrors({ formHook });

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridItem>
                        <GridRow>
                            <ExtensionsProporsionInfo
                                desktopText={"1500x844px (max 400KB)"}
                                mobileText={"1200x 675px (max 250KB)"}
                                proportion={"16:9"}
                            />
                        </GridRow>
                    </GridItem>

                    <OrderableImages orderableImagesHook={orderableImagesHook} />
                </>
            )}
        </>
    );
}

export default SectionGalleryForm;
